import { useEffect } from "react";
import { LandingLayout } from "@/components/landing/LandingLayout";
import { PublicHeader } from "@/components/public/PublicHeader";
import { PublicFooter } from "@/components/public/PublicFooter";
import { LandingHero } from "@/components/landing/LandingHero";
import { LandingFeatures } from "@/components/landing/LandingFeatures";
import { LandingShowcase } from "@/components/landing/LandingShowcase";
import { LandingHowItWorks } from "@/components/landing/LandingHowItWorks";
import { LandingPortfolio } from "@/components/landing/LandingPortfolio";
import { LandingPricing } from "@/components/landing/LandingPricing";
import { LandingFaq } from "@/components/landing/LandingFaq";
import { LandingFinalCta } from "@/components/landing/LandingFinalCta";
import { trackEvent } from "@/services/analytics/analyticsService";

export function Landing() {
  useEffect(() => {
    trackEvent("view_landing");
  }, []);

  return (
    <LandingLayout
      header={<PublicHeader context="home" />}
      footer={<PublicFooter context="home" />}
    >
      <LandingHero />
      <LandingShowcase />
      <LandingHowItWorks />
      <LandingFeatures />
      <LandingPortfolio />
      <LandingPricing />
      {/* <LandingFaq /> */}
      <LandingFinalCta />
    </LandingLayout>
  );
}
